import client from "@/utils/api/client";
import { ProjectResponse } from "@/web-client/api";
import useSWR from "swr";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import useQueryString from "@/hooks/useQueryString";

type UseLatestProjects = {
  projects: ProjectResponse[];
  mutate: (projects?: ProjectResponse[], shouldRevalidate?: boolean) => void;
};

const useLatestProjects = (
  limit: number,
  param?: ArchitectureSearchQueryParameter,
): UseLatestProjects => {
  const queryString = useQueryString(param);

  const { data, mutate } = useSWR<ProjectResponse[]>(
    `/latest_projects?${queryString}`,
    async () => {
      const { data } = await client.projectsSearchGet({
        buildingTypeId: param ? Number(param.building_type_id) : undefined,
        limit,
      });

      return data.results;
    },
  );

  return { projects: data || [], mutate };
};

export default useLatestProjects;
